// extracted by mini-css-extract-plugin
export default {"singleInput":"InlineUnitTypeInput_singleInput__8Xw2S","currencyInput":"InlineUnitTypeInput_currencyInput__2BL6h"};